export const POKEMON_API_URL = "https://pokeapi.co/api/v2";
export const GEN_5_LIMIT = 649;
